import React, {
  useState,
  useEffect,
  memo,
  useCallback,
  ReactElement,
} from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import "./style.scss";

interface TabItem {
  text: string;
  function?: ReactElement;
  key: string;
  disabled?: boolean;
}

interface CustomTabProps {
  data: TabItem[];
  activeKey: string;
  onTabChange?: (key: string | null) => void;
  customTab?: string;
  alignWithFilter?: boolean;
  top?: string | number;
  zInd?: number;
}

const CustomTab: React.FC<CustomTabProps> = ({
  data,
  activeKey: propActiveKey,
  onTabChange,
  customTab,
  alignWithFilter = false,
  top,
  zInd,
}) => {
  const [activeKey, setActiveKey] = useState<string>(propActiveKey);

  const handleTabSelect = useCallback(
    (key: string | null) => {
      setActiveKey(key || "");
      onTabChange?.(key);
    },
    [onTabChange]
  );

  useEffect(() => {
    setActiveKey(propActiveKey);
  }, [propActiveKey]);

  return (
    <Tabs
      id="fill-tab-example"
      activeKey={activeKey}
      onSelect={handleTabSelect}
      fill
      style={{ top, zIndex: zInd ?? (top ? 1000 : undefined), }}
      className={"mb-3 customTab mt-3"}
    >
      {data.map((tab) => (
        <Tab
          eventKey={tab.key}
          title={tab.text}
          key={tab.key}
          disabled={tab.disabled ?? false}
        >
          {tab.function}
        </Tab>
      ))}
    </Tabs>
  );
};

export default memo(CustomTab);
